// @flow
import type {SearchRequest} from '../models/SearchRequest';
import type {Options} from './SearchUrlParser';
import GTSearchUrlParser from './GTSearchUrlParser';

export default class BrazilSearchUrlParser extends GTSearchUrlParser {
    parse(url: string, options: Options = {}): SearchRequest {
        if (typeof window === 'undefined') {
            const districtRegion = require('../data/brazil_bairronav_regionAndTerm.json');
            const cityRegion = require('../data/brazil_cidade_regionAndTerm.json');
            const stateRegion = require('../data/brazil_estado_regionAndTerm.json');

            const urlParser = require('url');
            const parsedUrl = urlParser.parse(url);

            const queryParams = require('query-string').parse(
                parsedUrl.query || ''
            );

            // Order matters. Maps are presented here in precision order
            // starting from the most precise one
            const regionMaps = [
                {name: 'BairroNav', valueMap: districtRegion},
                {name: 'Cidade', valueMap: cityRegion},
                {name: 'Estado', valueMap: stateRegion}
            ];

            for (const regionMapObj of regionMaps) {
                let regionMapName = regionMapObj.name;

                if (
                    queryParams[regionMapName] &&
                    !Array.isArray(queryParams[regionMapName])
                ) {
                    let ids =
                        regionMapObj.valueMap[
                            decodeURI(queryParams[regionMapName])
                        ];

                    if (ids) {
                        if (Array.isArray(ids)) {
                            return {
                                regionId: ids[0],
                                searchTermUuid: ids[1]
                            };
                        }

                        return {
                            regionId: ids
                        };
                    }
                }
            }
        }

        // default to normal GT logic
        return super.parse(url, options);
    }
}
